import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFaceAnxiousSweat } from '@fortawesome/pro-light-svg-icons';

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(error, info);
    // TODO: Log the error in the BE
  }

  handleGoToDashboard = () => {
    this.props.onGoToDashboard();
    this.setState({ hasError: false });
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    // Canvas-embedded routes live under /lti/:session and don't go through
    // IdentityGate's Shibboleth login, so a plain "/" would strand an LTI
    // user there instead of back on their course dashboard.
    const ltiMatch = window.location.pathname.match(/^\/lti\/[^/]+/);
    const dashboardHref = ltiMatch ? ltiMatch[0] : '/';
    const actionProps = this.props.onGoToDashboard
      ? { onClick: this.handleGoToDashboard }
      : { href: dashboardHref };

    return (
      <Box className="mss__errorBoundary">
        <FontAwesomeIcon icon={faFaceAnxiousSweat} className="icon" fixedWidth />
        <Typography component="h2">Oh No!</Typography>
        <Typography component="h3">Something Went Wrong</Typography>
        <Typography component="p">
          Please try again later, or{' '}
          <a
            href="https://oduprod.service-now.com/now/nav/ui/classic/params/target/incident.do"
            target="_blank"
            rel="noopener noreferrer"
          >
            contact the ITS Help Desk
          </a>{' '}
          if the issue persists.
        </Typography>
        <Button variant="contained" className="mss__button" {...actionProps}>
          Go to Dashboard
        </Button>
      </Box>
    );
  }
}

export default ErrorBoundary;
